import React, { useCallback } from 'react';
import { longRunTableData } from 'service/service';
import CustomAnalysisTableBase from './CustomAnalysisTableBase';

const columnMapping: Record<string, string> = {
    workspace_name: 'Workspace Name',
    workspace_id: 'Workspace ID',
    job_name: 'Job Name',
    duration_seconds: 'Duration (Hrs)',
    trigger_type: 'Trigger Type',
    job_type: 'Job Type',
    run_as: 'Run As',
    dbu: 'DBU',
    compute_cost: 'Compute Cost'
};

const defaultColumns = ['Workspace Name', 'Workspace ID', 'Job Name', 'Duration (Hrs)', 'Trigger Type', 'Job Type', 'Run As', 'DBU', 'Compute Cost'];

const LongRunningJobsPage = () => {
    const filterTableDataFn = useCallback((data: any[], mapping: Record<string, string>) => {
        return data.map((row) => {
            const filtered: Record<string, any> = {};
            Object.keys(mapping).forEach((key) => {
                if (key === "duration_seconds" && typeof row[key] === "number") {
                    const hours = Math.floor(row[key] / 3600);
                    const days = Math.floor(row[key] / 86400);
                    filtered[key] = `${days} days (${hours} hrs)`;
                } else {
                    filtered[key] = row[key];
                }
            });
            return filtered;
        });
    }, []);

    return (
        <CustomAnalysisTableBase
            fetchService={longRunTableData}
            columnMapping={columnMapping}
            defaultColumns={defaultColumns}
            filterTableDataFn={filterTableDataFn}
            breadcrumbLabel="Long Running Jobs"
            tableTitle="Long Running Jobs"
            tableType="incident-details-ver"
            preserveFilterKey="long_run_filters"
            isAutoWidth={true}
        />
    );
};

export default LongRunningJobsPage;
